export default __webpack_public_path__ + "static/media/background.e6449c85.jpg";